import _debounce from 'lodash.filter';

export function debounce(callback: any, delay: number) {
  return _debounce((...args: any) => callback(...args), delay);
}
